import { LiveMap } from '@liveblocks/client'
import { RoomProvider } from '@liveblocks/react'
import { ParticipantNote } from '@seen/core/models/participantNote'
import { type ReactNode, useMemo } from 'react'

export function ParticipantRoomProvider({
  participantId,
  children,
}: {
  participantId: string
  children: ReactNode
}): ReactNode {
  const initialStorage = useMemo(
    () => ({
      seededFields: new LiveMap<string, boolean>(),
    }),
    []
  )
  return (
    <RoomProvider
      key={participantId}
      id={ParticipantNote.roomIdForParticipant(participantId)}
      initialStorage={initialStorage}
    >
      {children}
    </RoomProvider>
  )
}
